module.exports = __webpack_public_path__ + "img/Nyheter24.86144183.png";